// extracted by mini-css-extract-plugin
export var emailBlockLink = "_ky-0";